import React from "react";
import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { Reveal } from "./Reveal";

const IMG = "https://images.unsplash.com/photo-1551288049-bebda4e38f71?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBkYXJrJTIwZGFzaGJvYXJkJTIwdWklMjBzYWFzfGVufDB8fHx8MTc4NTEwMTM1Nnww&ixlib=rb-4.1.0&q=85";

const POINTS = [
  "Live status across every document",
  "Upcoming deadlines ranked by urgency",
  "AI analysis with confidence + source attribution",
  "Ask DOX anything about your paperwork",
];

export default function DashboardPreview() {
  return (
    <section id="dashboard" className="relative py-24 sm:py-32 overflow-hidden">
      <div className="glow-orb w-[520px] h-[520px] right-[-160px] top-10 bg-dox-orange/12" />
      <div className="mx-auto max-w-7xl px-5 sm:px-8 grid lg:grid-cols-2 gap-14 items-center">
        <Reveal>
          <div className="text-xs font-bold tracking-[0.25em] uppercase text-dox-magenta mb-5">The Command Center</div>
          <h2 className="font-display font-black tracking-tight text-4xl sm:text-5xl leading-[1.05]">
            One dashboard. <span className="text-gradient-brand">Total clarity.</span>
          </h2>
          <p className="mt-6 text-lg text-white/60 leading-relaxed max-w-xl">
            See exactly where your business stands — what’s compliant, what needs action, and what’s due next.
            DOX keeps it all current, so you don’t have to.
          </p>
          <ul className="mt-8 space-y-3">
            {POINTS.map((p) => (
              <li key={p} className="flex items-start gap-3">
                <span className="mt-0.5 inline-flex h-5 w-5 items-center justify-center rounded-full bg-dox-orange/15 text-dox-orange shrink-0">
                  <Check size={13} />
                </span>
                <span className="text-white/70 text-sm">{p}</span>
              </li>
            ))}
          </ul>
        </Reveal>

        <Reveal delay={0.15}>
          <motion.div
            whileHover={{ rotate: -1, scale: 1.01 }}
            transition={{ type: "spring", stiffness: 200, damping: 20 }}
            className="relative rounded-2xl overflow-hidden border border-white/10 shadow-2xl"
          >
            <div className="absolute inset-0 bg-gradient-to-t from-ink via-transparent to-transparent z-10" />
            <div className="absolute inset-0 bg-gradient-to-tr from-dox-purple/25 to-dox-orange/10 mix-blend-overlay z-10" />
            <img src={IMG} alt="EZDoxAI compliance dashboard" className="w-full h-[440px] object-cover" />
            <div className="absolute bottom-5 left-5 z-20 glass rounded-xl px-4 py-3">
              <div className="text-xs text-white/50">Compliance score</div>
              <div className="font-display font-black text-2xl text-gradient-brand">98%</div>
            </div>
          </motion.div>
        </Reveal>
      </div>
    </section>
  );
}
